import { NavItem, styled } from '@cad-arc';
export const FrNavItem = styled(NavItem)`
    margin-top: 0;

    & svg {
        width: 24px;
        height: 24px;
    }
`;
